module.exports = __webpack_public_path__ + "img/no-search.12165646.png";